<script setup lang="ts">
import { computed } from 'vue';

import { PoolNote } from '@/types/untangled/pool';
import instance from '@/services/api/untangled-axios';
import { getRawHtml } from '@/lib/utils/etc';

/**
 * TYPES
 */
type Props = {
  poolNote: PoolNote;
};

/**
 * PROPS & EMITS
 */
const props = defineProps<Props>();

/**
 * COMPOSABLES
 */
const poolCard = ref<any>();
const loading = ref(false);

watchEffect(async () => {
  loading.value = true;
  const poolId = props.poolNote.poolId;
  const { data } = await instance.get(`/api/v1/pool-migration/${poolId}`);
  loading.value = false;
  const _poolCard = data?.data?.poolNotification?.poolCard?.published;

  poolCard.value = {
    label: _poolCard?.label,
    content: _poolCard?.content ? getRawHtml(_poolCard.content) : undefined,
  };
});

const label = computed(() => poolCard?.value?.label ?? 'Upon request');
const tooltip = computed(
  () =>
    poolCard?.value?.content ??
    'This pool is qualified for our liquidation mechanism. Liquidity providers can exit the pool at a given notice subject to a liquidation bonus.'
);
</script>

<template>
  <div :class="['flex justify-end py-4 px-6 -mt-1 font-numeric text-right']">
    <BalLoadingBlock v-if="loading" class="w-12 h-4" />
    <div v-else class="flex gap-4 items-center">
      <span>{{ label }}</span>
      <BalTooltip v-if="tooltip" width="48" iconSize="sm" class="mt-1">
        <div v-html="tooltip"></div>
      </BalTooltip>
    </div>
  </div>
</template>
